import React, { useEffect } from 'react';
import { Box, Typography, Grid, Paper, Divider, Avatar, Link, Button } from '@mui/material';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

interface DocumentProps {
    listOfData: any;
    show?: boolean;
}

const Document: React.FC<DocumentProps> = ({ listOfData }) => {
    const handleDownload = async () => {
        const input = document.getElementById('htmlContent');
        if (!input) {
            alert('PDF oluşturulamadı: Element bulunamadı');
            return;
        }

        // Element boyutlarını kontrol et
        const rect = input.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) {
            alert('PDF oluşturulamadı: Element görünür değil');
            return;
        }

        try {
            const canvas = await html2canvas(input, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                logging: false,
                removeContainer: true
            } as any);
            if (canvas.width === 0 || canvas.height === 0) {
                alert('PDF oluşturulamadı: Canvas boş');
                return;
            }

            const imgData = canvas.toDataURL('image/png', 1.0);
            if (imgData.length < 1000) {
                alert('PDF oluşturulamadı: Image data boş');
                return;
            }

            // PDF oluştur
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            // Canvas oranını koru
            const canvasAspectRatio = canvas.width / canvas.height;
            const pdfAspectRatio = pdfWidth / pdfHeight;

            let imgWidth = pdfWidth;
            let imgHeight = pdfHeight;

            if (canvasAspectRatio > pdfAspectRatio) {
                imgHeight = pdfWidth / canvasAspectRatio;
            } else {
                imgWidth = pdfHeight * canvasAspectRatio;
            }

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

            // PDF'i yeni tabta aç
            const pdfBlob = pdf.output('blob');
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            alert('PDF oluşturma hatası: ' + error);
        }
    };

    useEffect(() => {
        if (listOfData && listOfData.data && listOfData.data.data) {
            setTimeout(() => {
                handleDownload();
            }, 500); // DOM'un tam render olması için 2 saniye bekle
        }
    }, [listOfData])


    return (
        <Box sx={{ position: 'relative', zIndex: -100000, width: 0, height: 0, background: 'transparent', opacity: 0, overflowX: 'hidden' }}>
            {listOfData && listOfData.data && listOfData.data.data && listOfData.data.data.length > 0 && (
                <Paper
                    sx={{
                        padding: "10px",
                        width: '210mm',
                        height: '297mm',
                        borderRadius: 2,
                        overflow: 'hidden',
                        bgcolor: '#fff',
                        mx: 'auto',
                        position: 'relative !important',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: -100000,
                    }}
                    id="htmlContent"
                    elevation={3}
                >

                    <Box sx={{
                        width: '100%',
                        height: 83,
                        bgcolor: '#002ABE',
                        position: 'absolute',
                        top: "195px"
                    }} />

                    <Box sx={{
                        opacity: 1,
                        borderRadius: 2,
                        bgcolor: '#E9E9E9',
                        width: 'calc(100% - 20px)',
                        height: 'calc(100% - 20px)',
                        position: 'relative',
                    }}>
                        {/*  <Box sx={{ width: '100%', height: '100%', }}> */}
                        <Avatar
                            src={process.env.PUBLIC_URL + "/assets/images/logo/sidenavlogo.png"}
                            alt="AHL PAY Logo"
                            sx={{ width: "300px", height: "auto", m: 2, zIndex: 2 }}
                            variant="square"
                        />
                        <Divider sx={{ width: 645, borderColor: 'primary.main', ml: 13, borderWidth: 2, zIndex: 2 }} />
                        <Box sx={{
                            width: '100%',
                            height: 83,
                            bgcolor: '#002ABE',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            px: 3,
                            pb: 2.5,
                            zIndex: 1,
                            mt: 8,
                            mb: 1
                        }}>
                            <Grid container alignItems="center" mt={2}>
                                <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                                    <Typography sx={{ fontSize: 11, m: 0, color: '#fff' }}>
                                        Dekont No: {listOfData?.data?.receiptNo}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'center' }}>
                                    <Typography sx={{ fontSize: 18, fontWeight: 'bold', m: 0, color: '#fff' }}>Dekont</Typography>
                                    <Typography sx={{ fontSize: 12, fontWeight: 'bold', m: 0, color: '#fff' }}>(Elektronik Para Kuruluşu)</Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', height: '100%' }}>
                                    <Typography sx={{ fontSize: 11, m: 0, color: '#fff' }}>
                                        Düzenleme Tarihi: {listOfData?.data?.eDate}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        {listOfData?.data?.isSignature && (
                            <Avatar
                                src={process.env.PUBLIC_URL + "/assets/images/logo/imza_kase.png"}
                                alt="imza_kase.png"
                                sx={{ height: 399, width: 'auto', position: 'absolute', bottom: 0, right: 0, zIndex: 2 }}
                                variant="square"
                            />
                        )}
                        <Box sx={{ mt: 2, position: 'relative !important', zIndex: 1 }}>
                            <Grid container spacing={0} sx={{ borderTop: '1px solid #fff' }}>
                                {listOfData?.data?.data?.map((item: any, idx: number) => (
                                    <Grid item xs={12} sm={6} key={idx} sx={{ 
                                        borderBottom: '1px solid #fff',
                                        borderRight: idx % 2 === 0 ? '1px solid #fff' : 'none'
                                    }}>
                                        <Box sx={{ display: 'flex', width: '100%', py: 1.5 }}>
                                            <Box sx={{ width: '40%', pl: 2 }}>
                                                <Typography sx={{ 
                                                    color: '#5C5C5C', 
                                                    fontSize: item.title.length > 20 ? 9 : (item.title.length > 15 ? 10 : 11), 
                                                    fontWeight: 400, 
                                                    m: 0,
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}>{item.title}:</Typography>
                                            </Box>
                                            <Box sx={{ width: '60%', pl: 2 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: item.content.includes('TR') ? 11 : (item.content.length > 35 ? 10 : (item.content.length > 30 && item.content.length <= 35 ? 10 : 12)),
                                                        color: '#000',
                                                        fontWeight: 400,
                                                        wordBreak: 'break-word',
                                                        m: 0,
                                                    }}
                                                >
                                                    {item.content}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                            <Box sx={{ mt: 5 }}>
                                <Typography sx={{ color: '#000', fontSize: 16, fontWeight: 400, pl: 2, py: 3, mt: 5, textDecorationSkipInk: 'none', textUnderlinePosition: 'from-font' }}>
                                    AHLATCI ÖDEME VE ELEKTRONİK PARA HİZMETLERİ A.Ş.
                                </Typography>
                                <Typography sx={{ color: '#5C5C5C', fontSize: 12, fontWeight: 400, pl: 2, py: 1, borderBottom: '1px solid #FCFCFE' }}>
                                    Vergi Dairesi: <Box component="span" sx={{ color: '#000', fontSize: 12 }}>Alemdağ</Box>
                                </Typography>
                                <Typography sx={{ color: '#5C5C5C', fontSize: 12, fontWeight: 400, pl: 2, py: 1, borderBottom: '1px solid #FCFCFE' }}>
                                    Vergi Kimlik Numarası: <Box component="span" sx={{ color: '#000', fontSize: 12 }}>0101392161</Box>
                                </Typography>
                                <Typography sx={{ color: '#5C5C5C', fontSize: 12, fontWeight: 400, pl: 2, py: 1, borderBottom: '1px solid #FCFCFE' }}>
                                    Mersis Numarası: <Box component="span" sx={{ color: '#000', fontSize: 12 }}>0010-1392-1610-0001</Box>
                                </Typography>
                            </Box>
                        </Box>
                        {listOfData?.data?.isSignature && (
                            <Typography sx={{ fontSize: 13, zIndex: 2, pl: 2, position: 'absolute', bottom: '50px' }}>
                                * İşlem ücretine BSMV dahil edilmiştir.
                            </Typography>
                        )}
                        <Box sx={{ width: '100%', pb: 1, position: 'absolute', bottom: '0', }}>
                            <Divider sx={{ borderColor: '#002ABE', width: "100%", borderWidth: 1, mb: 1, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }} />
                            <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', px: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Avatar src={process.env.PUBLIC_URL + "/assets/images/svg/location.svg"} alt="location" sx={{ height: 16, width: 16, }} variant="square" />
                                        <Typography sx={{ ml: 1, /* mb: 1.5, */ fontSize: 12 }}>
                                            Yamanevler Mah. Ahmet Tevfik İleri Cad. 4B Plaza No:26 Kat:9 Ümraniye / İstanbul
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Avatar src={process.env.PUBLIC_URL + "/assets/images/svg/sms.svg"} alt="sms" sx={{ height: 16, width: 16, }} variant="square" />
                                        <Link href="mailto:info@ahipay.com.tr" sx={{ ml: 1, /* mb: 1.5, */ mr: 3, textDecoration: 'none', color: '#000', fontSize: 12 }}>
                                            info@ahipay.com.tr
                                        </Link>
                                        <Avatar src={process.env.PUBLIC_URL + "/assets/images/svg/call.svg"} alt="call" sx={{ height: 16, width: 16, }} variant="square" />
                                        <Typography sx={{ ml: 1, /* mb: 1.5, */ fontSize: 12 }}>
                                            444 90 66
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            )}
        </Box>
    );
};

export default Document;